import AOS from 'aos';

export default {
    mounted() {
        AOS.init({
            // Global settings
            startEvent: 'DOMContentLoaded', // Event to initialize on
            initClassName: 'aos-init', // Class applied after initialization
            animatedClassName: 'aos-animate', // Class applied on animation
            useClassNames: false, // Use `data-aos` as classes on scroll
            debounceDelay: 50, // Delay on debounce for window resize
            throttleDelay: 99, // Delay on throttle for page scroll

            // Per-element settings (can be overridden using `data-aos-*` attributes)
            offset: 100, // Offset (in px) from trigger point
            delay: 0, // Delay (0 to 3000, step 50ms)
            duration: 400, // Duration (0 to 3000, step 50ms)
            easing: 'ease', // Easing for AOS animations
            once: true, // Animate only once while scrolling down
            mirror: false, // Animate out while scrolling past elements
            anchorPlacement: 'top-center', // Position of element vs window to trigger animation

            // Disable AOS for bots/crawlers
            disable: () =>
                /bot|googlebot|crawler|spider|robot|crawling/i.test(
                    navigator.userAgent
                ),
        });

        window.addEventListener('load', AOS.refresh);
    },
};
